// Mock data for Three Spheres Healthcare website

export const heroImages = {
  main: "https://images.unsplash.com/photo-1604881991720-f91add269bed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxtZW50YWwlMjBoZWFsdGglMjBjYXJlfGVufDB8fHx8MTc3MDQ1MTc2Nnww&ixlib=rb-4.1.0&q=85"
};

export const staffImages = [
  "https://images.unsplash.com/photo-1666887360680-9dc27a1d2753?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxoZWFsdGhjYXJlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MDM2NjMzNHww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/30425693/pexels-photo-30425693.jpeg",
  "https://images.pexels.com/photos/8460157/pexels-photo-8460157.jpeg"
];

export const supportedLivingImages = [
  "https://images.unsplash.com/photo-1696774275614-8af905e80d57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjb21mb3J0YWJsZSUyMGhvbWUlMjBsaXZpbmd8ZW58MHx8fHwxNzM4OTU4MjQwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1509647924673-bbb53e22eeb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxjb21mb3J0YWJsZSUyMGhvbWUlMjBsaXZpbmd8ZW58MHx8fHwxNzM4OTU4MjQwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1758273706306-d1da2e801fc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxjb21mb3J0YWJsZSUyMGhvbWUlMjBsaXZpbmd8ZW58MHx8fHwxNzM4OTU4MjQwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1483095348487-53dbf97d8d5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjb3p5fGVufDB8fHx8MTczODk1ODI5NXww&ixlib=rb-4.1.0&q=85"
];

export const servicesList = [
  {
    id: 1,
    title: "Supported Living",
    description: "Person-centered support for adults with mental health conditions to live independently in the community with dignity and choice.",
    icon: "Home",
    link: "/supported-living"
  },
  {
    id: 2,
    title: "Mental Health Support",
    description: "Specialist support from RMN-led teams for individuals with complex mental health needs and co-occurring conditions.",
    icon: "Heart",
    link: "/services"
  },
  {
    id: 3,
    title: "Healthcare Staffing",
    description: "High-quality temporary and permanent staffing solutions - RMNs, RGNs, HCAs, and support workers for care providers.",
    icon: "Users",
    link: "/staffing"
  },
  {
    id: 4,
    title: "Care Coordination",
    description: "Holistic care planning, risk management, and multidisciplinary liaison to ensure safe, effective, and responsive care.",
    icon: "FileText",
    link: "/services"
  }
];

export const valuesToRespect = [
  {
    id: 1,
    title: "Safety First",
    description: "Rigorous safeguarding, risk management, and clinical governance underpin everything we do.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Dignity & Respect",
    description: "Every individual deserves to be treated with compassion, understanding, and person-centered care.",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Recovery-Focused",
    description: "We believe in empowering individuals to regain confidence, independence, and meaningful lives.",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Evidence-Based Practice",
    description: "Our approach is grounded in clinical expertise, academic insight, and continuous learning.",
    icon: "BookOpen"
  },
  {
    id: 5,
    title: "Cultural Competence",
    description: "We respect diversity and provide culturally sensitive, inclusive care for all individuals.",
    icon: "Globe"
  },
  {
    id: 6,
    title: "Professional Excellence",
    description: "RMN-led leadership, ongoing supervision, training, and reflective practice ensure high standards.",
    icon: "Award"
  }
];

export const statsData = [
  { value: "RMN-Led", label: "Clinical Leadership" },
  { value: "24/7", label: "Support Available" },
  { value: "Person-Centred", label: "Care Approach" },
  { value: "CQC-Ready", label: "Compliance Standards" }
];

export const jobRoles = [
  {
    id: 1,
    title: "Registered Mental Health Nurse (RMN)",
    type: "Permanent & Bank",
    description: "Lead on complex care planning, risk assessment, and clinical supervision for supported living services.",
    requirements: ["Valid NMC registration", "Mental health nursing experience", "Risk assessment skills", "Knowledge of Mental Health Act and MCA"]
  },
  {
    id: 2,
    title: "Registered General Nurse (RGN)",
    type: "Bank",
    description: "Provide physical health monitoring, medication support, and clinical input for individuals with mental health needs.",
    requirements: ["Valid NMC registration", "Experience in community or mental health settings preferred", "Medication administration skills"]
  },
  {
    id: 3,
    title: "Healthcare Assistant (HCA)",
    type: "Permanent & Bank",
    description: "Support individuals with daily living, personal care, and engagement in meaningful activities.",
    requirements: ["Care Certificate or equivalent", "Experience in mental health or social care", "Compassionate and patient approach"]
  },
  {
    id: 4,
    title: "Support Worker",
    type: "Permanent & Bank",
    description: "Provide practical and emotional support to help individuals maintain independence and community links.",
    requirements: ["Experience in social care or support work", "Understanding of mental health needs", "Good communication skills"]
  }
];

export const complianceAreas = [
  {
    title: "CQC Registration",
    description: "Working toward CQC registration for supported living and domiciliary care services.",
    icon: "CheckCircle"
  },
  {
    title: "Safeguarding",
    description: "Robust safeguarding policies, DBS checks, and mandatory training for all staff members.",
    icon: "Shield"
  },
  {
    title: "Clinical Governance",
    description: "Regular audits, incident reviews, supervision, and continuous quality improvement processes.",
    icon: "FileText"
  },
  {
    title: "Data Protection",
    description: "GDPR-compliant handling of personal information, secure record-keeping, and confidentiality protocols.",
    icon: "Lock"
  },
  {
    title: "Health & Safety",
    description: "Risk assessments, infection control, medication management, and safe working practices.",
    icon: "AlertTriangle"
  },
  {
    title: "Staff Training",
    description: "Mandatory training, clinical supervision, reflective practice, and ongoing professional development.",
    icon: "BookOpen"
  }
];

export const mockContactSubmissions = [];
